import { render, staticRenderFns } from "./QuanLyHeThongThongTin.vue?vue&type=template&id=1d2850b5"
import script from "./QuanLyHeThongThongTin.vue?vue&type=script&lang=js"
export * from "./QuanLyHeThongThongTin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports